import { combineReducers, configureStore, Tuple } from '@reduxjs/toolkit';
import createSagaMiddleware from 'redux-saga';
import { spawn } from 'redux-saga/effects';
import { EnhancedStore } from '@reduxjs/toolkit/src/configureStore';
import { useDispatch } from 'react-redux';
import { Store } from 'redux';
import {
  moduleName as authModuleName, auth, saga as authSaga,
} from './auth';
import { moduleName as userModuleName, user, saga as userSaga } from './user';
import { moduleName as commonModuleName, common, saga as commonSaga } from './common';
import { moduleName as categoryModuleName, category, saga as categorySaga } from './category';
import { moduleName as commentModuleName, comment, saga as commentSaga } from './comment';
import { moduleName as subCategoryModuleName, subCategory, saga as subCategorySaga } from './subCategory';
import { moduleName as businessModuleName, business, saga as businessSaga } from './business';
import { moduleName as postModuleName, post, saga as postSaga } from './post';
import { moduleName as internationalModuleName, international, saga as internationalSaga } from './international';
import { moduleName as statisticModuleName, statistic, saga as statisticSaga } from './statistic';

export const sagaMiddleware = createSagaMiddleware();

const store: Store = configureStore({
  reducer: combineReducers({
    [authModuleName]: auth.reducer,
    [userModuleName]: user.reducer,
    [commonModuleName]: common.reducer,
    [categoryModuleName]: category.reducer,
    [commentModuleName]: comment.reducer,
    [subCategoryModuleName]: subCategory.reducer,
    [businessModuleName]: business.reducer,
    [postModuleName]: post.reducer,
    [internationalModuleName]: international.reducer,
    [statisticModuleName]: statistic.reducer,
  }),
  middleware: () => new Tuple(sagaMiddleware),
  devTools: process.env.REACT_APP_ENV !== 'production',
});

const storeType = (store as EnhancedStore);

export type RootState = ReturnType<typeof storeType.getState>;
export type AppDispatch = typeof store.dispatch;

const useAppDispatch = () => useDispatch<AppDispatch>();

sagaMiddleware.run(function* runSaga() {
  yield spawn(authSaga, store);
  yield spawn(commonSaga, store);
  yield spawn(userSaga);
  yield spawn(categorySaga);
  yield spawn(commentSaga);
  yield spawn(subCategorySaga);
  yield spawn(businessSaga);
  yield spawn(postSaga);
  yield spawn(internationalSaga);
  yield spawn(statisticSaga);
});

export default store;
